module.exports = __webpack_public_path__ + "assets/img/produccion-packaging-personalizado-rakumart-2.a45ea3fc.jpg";